<template>
  <router-view />
</template>

<script>
export default {
  name: "VirtualClassroomsIndex",
};
</script>
